<template>
  <profile-setting></profile-setting>
</template>

<script>
export default {
  name: 'ProfileSettingAdmin',
  data() {
    return {};
  }
};
</script>

<style></style>
